import React from 'react';
import PropTypes from 'prop-types';

// Shared V2-status loading spinner.
function LoadingSpinner({ message }) {
  return (
    <div className="d-flex align-items-center justify-content-center" style={{ minHeight: '400px' }}>
      <div className="text-center">
        <div className="spinner-border text-primary mb-3" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="text-muted">{message}</p>
      </div>
    </div>
  );
}

LoadingSpinner.propTypes = {
  message: PropTypes.string,
};

LoadingSpinner.defaultProps = {
  message: 'Loading...',
};

export default LoadingSpinner;
